exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ico-check {\n  width: 20px !important;\n  height: 20px !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -ms-transform: translate(-50%, -50%);\n      transform: translate(-50%, -50%); }\n  .ico-check i {\n    font-size: 8px !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    -ms-transform: translate(-50%, -50%);\n        transform: translate(-50%, -50%); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/standing-order-render/standing-order-render.component.scss
// module id = 1913
// module chunks = 66